<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DSourceEditor',
  extends: compoment
}
</script>
